export const mobileBannerUrl = "https://dev-assets.cdn.vivup.co.uk/en-GB/home_and_electronics_store_banner_mobile.png"

export const desktopBannerUrl = "https://assets.cdn.vivup.co.uk/en-GB/home_and_electronics_store_banner.png"

export interface RoundelProps {
  imageUrl: string
  link: string
  label: string
  __typename: string
}

export const trending: RoundelProps[] = [
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE1MzMwOCwicHVyIjoiYmxvYl9pZCJ9fQ==--45bf2f7a2e0cd0ca1480fe7d1d6d266ecf812bfa/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITHOUT_LOGO_-_APPLE_AirPods_(4th_Gen)_with_Active_Noise_Cancellation_(MXP93ZMA).png",
    link: "/departments/15",
    label: "Headphones \u0026 Earphones",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjIxMjQ3NywicHVyIjoiYmxvYl9pZCJ9fQ==--d88f9760bac9ce12ccace8fe27a510ad9973633e/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITH_\u0026_WITHOUT_Currys_Logo_-_APPLE_8.png",
    link: "/departments/15",
    label: "Tablets \u0026 iPads",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjM3NTUxNCwicHVyIjoiYmxvYl9pZCJ9fQ==--e775b55ec4af1b11a88ac23d6d1ac913ae163fd2/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITHOUT_JLP_LOGO_-_DIOR_Sauvage_Eau_de_Parfum_-_100ml_(46428020).png",
    link: "/departments/15",
    label: "Fragrance",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjIxMjQ4OCwicHVyIjoiYmxvYl9pZCJ9fQ==--1ffd22d479c922c3d9b3e190f9ad40a127dd6dfe/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Call_of_Duty_Black_Ops_6,_PS5.png",
    link: "/departments/15",
    label: "Games",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE1NDUzMCwicHVyIjoiYmxvYl9pZCJ9fQ==--51069fc1a2313ec04fb90ac3600665369416f546/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITHOUT_CURRYS_LOGO_-_APPLE_Watch_Series_10_-_46_mm_Jet_Black_Aluminium_Case_with_Black_Sport_Band,_ML_(N396609W)-002.png",
    link: "/departments/15",
    label: "Smart Tech ",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE3MzA2NSwicHVyIjoiYmxvYl9pZCJ9fQ==--b63383b2c432fd3e14d561a94b0c5865cec22437/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/META_Quest_3S_Mixed_Reality_Headset_-_128_GB.png",
    link: "/departments/15",
    label: "Virtual Reality",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU1MjY3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--6c098ac675eebfc4593d56fe925f99f7861a9d74/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Without_JLP_Logo_-_Disney_Lilo_\u0026_Stitch_POP!_Jumbo_Stitch_Figure_with_Ukelele_(78638145)-001.png",
    link: "/departments/15",
    label: "Figurines \u0026 Play Sets",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU0MTYyMywicHVyIjoiYmxvYl9pZCJ9fQ==--f19726156d7d5e0610a07d0f240d72855a46f656/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/719843_-_MICROSOFT_Xbox_Series_S_-_1_TB_SSD.png",
    link: "/departments/15",
    label: "Gaming",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDg0NCwicHVyIjoiYmxvYl9pZCJ9fQ==--9ea10ed0969b3b906964699175e9cd5cac02683c/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/iPhone_16e_-_Black.png",
    link: "/departments/15",
    label: "Apple iPhones",
    __typename: "Roundel"
  },
  {
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjIxMjQ4NCwicHVyIjoiYmxvYl9pZCJ9fQ==--4e44d16d591fbe877daa3a1759fbf6b9c5b5c206/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITH_\u0026_WITHOUT__Currys_Logo_-_SHARK_HD652SUK_FlexFusion_Straight_5-in-1_Air_Styler_\u0026_Hair_Dryer_with_Storage_Case_-_Cosmic_Blush_(N680179W).png",
    link: "/departments/15",
    label: "Hair Care \u0026 Styling",
    __typename: "Roundel"
  }
]

export const departments: RoundelProps[] = [
  {
    label: "Computing \u0026 Gaming",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5ODE2MywicHVyIjoiYmxvYl9pZCJ9fQ==--b617c46d5b944a1cf9089809db9ac14fc1eb134f/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/PS5%20Pro%20-%20With%20Logo.png",
    __typename: "Roundel"
  },
  {
    label: "TV, Audio \u0026 Phones",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjIyODQ4NCwicHVyIjoiYmxvYl9pZCJ9fQ==--090d5bd75fb25a4f86bbf72cbec83f9be3e3b210/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITH_\u0026_WITHOUT_Currys_Logo_-_SAMSUNG_UE55DU7100KXXU_55_Smart_4K_Ultra_HD_HDR_LED_TV_with_Bixby_(B598153B).png",
    __typename: "Roundel"
  },
  {
    label: "Furniture \u0026 Lights",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE0MjcxNCwicHVyIjoiYmxvYl9pZCJ9fQ==--9d48070d6452c416120ea6f0ab5a309b0bb89972/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITH_JLP_LOGO_-_Silentnight_Recover_Miracoil_2_Drawer_Divan_Base_and_Mattress_Set,_Regular_Tension_(80059112).png",
    __typename: "Roundel"
  },
  {
    label: "Home",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjQzMTI5MSwicHVyIjoiYmxvYl9pZCJ9fQ==--13adc37e60a671371f9cd8de1607676f1b4a412d/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/HOME_-_JLP_LOGO_\u0026_NO_LOGO_-_Tefal_Ingenio_Emotion_Stainless_Steel_Pans,_Lids_\u0026_Utensils_Set,_22_Piece_(81344606).png",
    __typename: "Roundel"
  },
  {
    label: "Garden \u0026 Tools",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU0MTYxNCwicHVyIjoiYmxvYl9pZCJ9fQ==--7a46318e68ac1eba1c42aaf52cccfb32e7970984/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/GARDEN_-_JLP_LOGO_\u0026_NO_LOGO_-_John_Lewis_Alora_Cube_6-Seater_Garden_Dining_Table,_Sofas_\u0026_Stools_Set,_Brown_Grey_(82084703).png",
    __typename: "Roundel"
  },
  {
    label: "Appliances \u0026 Smart Tech",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU1MjY2MywicHVyIjoiYmxvYl9pZCJ9fQ==--269eee20c1f8e31762b68a0fd3c498f77fd7f2a2/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/With_Currys_logo_-_NINJA_SLUSHi_FS301UK_Frozen_Drink_Maker_-_Artic_Blue_\u0026_Grey_(N549467W).png",
    __typename: "Roundel"
  },
  {
    label: "Baby \u0026 Child",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU1MjY3NiwicHVyIjoiYmxvYl9pZCJ9fQ==--03d87714e130311c6b08cfdd7a04814fcc60538c/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/With_JLP_Logo_-_LEGO_Botanicals_10342_Pretty_Pink_Flower_Bouquet_(73220421).png",
    __typename: "Roundel"
  },
  {
    label: "Beauty \u0026 Accessories",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU1MjY3OSwicHVyIjoiYmxvYl9pZCJ9fQ==--2cc94a2dda6b7dc5320cf24edfac26656b9973ee/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/With_Currys_Logo_-_SHARK_FW312UK_CryoGlow_Under-Eye_Cooling_LED_Anti-Ageing_\u0026_Blemish_Repair_Mask_-_Blue_Frost_(N746828W).png",
    __typename: "Roundel"
  },
  {
    label: "Sport \u0026 Leisure",
    link: "/departments/15",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjEyNTA0NCwicHVyIjoiYmxvYl9pZCJ9fQ==--95460b145703fbdf57cb0e2f51942d560efac729/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITH_\u0026_WITHOUT_DECATHLON_LOGO_-_Domyos_Smart_Folding_10-_Motorised_Incline_Treadmill_Run500_(2711064).png",
    __typename: "Roundel"
  }
]

export const computingGaming: RoundelProps[] = [
  {
    label: "Computer Accessories",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTg5NjQ0OCwicHVyIjoiYmxvYl9pZCJ9fQ==--21812929e36cb95396a6ae1a6b050446ababf848/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Sol-de-Janeiro-Cheirosa-59-Dela-cia-Drench-Perfume-Mist-240ml-45280510-.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Desktop PCs",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTg5NjQ1MCwicHVyIjoiYmxvYl9pZCJ9fQ==--b4cf3d6c09d307c624e76bdd294b8c445e2855d0/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Sol-de-Janeiro-Cheirosa-59-Dela-cia-Drench-Perfume-Mist-240ml-45280523-.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Gaming",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjU0MTYyMywicHVyIjoiYmxvYl9pZCJ9fQ==--f19726156d7d5e0610a07d0f240d72855a46f656/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/719843_-_MICROSOFT_Xbox_Series_S_-_1_TB_SSD.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Laptops \u0026 Macbooks",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6OTk4LCJwdXIiOiJibG9iX2lkIn19--f1b62c515d96448e8e8f4e423c92287c8db3ef64/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Laptops___Macbooks__(N852647W).png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "PC Gaming",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6OTk5LCJwdXIiOiJibG9iX2lkIn19--6228f88b4a8006879ccd57b0955ff77d3bf44911/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/PC_Gaming_(N528576W).png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Printing",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTgxNjIxNiwicHVyIjoiYmxvYl9pZCJ9fQ==--da83bc596fe4df3140445b9510b5ebeb2cd81826/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/CANON-PIXMA-TS3355-All-in-One-Wireless-Inkjet-Printer-N729106W-.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Software",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTgxNjQ2OSwicHVyIjoiYmxvYl9pZCJ9fQ==--f10275f44ba61ab01a161a412847de3bb6335321/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/MCAFEE-Total-Protection-1-year-for-1-device-N699282W-.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Tablets \u0026 iPads",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjIxMjQ3NywicHVyIjoiYmxvYl9pZCJ9fQ==--d88f9760bac9ce12ccace8fe27a510ad9973633e/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/WITH_\u0026_WITHOUT_Currys_Logo_-_APPLE_8.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "Wifi \u0026 Networking",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTAwMywicHVyIjoiYmxvYl9pZCJ9fQ==--7c7502d0990b5eecea627a084f4d457ec0c1f84d/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Wifi___Networking_(N782006W)_copy.png",
    link: "/products",
    __typename: "Roundel"
  },
  {
    label: "All Computing & Gaming",
    imageUrl:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTE0NCwicHVyIjoiYmxvYl9pZCJ9fQ==--eab3f1572390b270697fe7682d7ffaa70ae7c9d1/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIyMzB4MjMwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7e8ef3790e7c41411e8707204af77bfb4fc22680/Computing.png",
    link: "/products",
    __typename: "Roundel"
  }
]

export const products = [
  {
    id: "565298-440",
    productId: 565298,
    brochureGroupId: 440,
    name: "SONY PlayStation 5 Pro",
    price: 26.85,
    totalAmount: "644.4",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/565298?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjIzNzcxMywicHVyIjoiYmxvYl9pZCJ9fQ==--be9d5fd98fa3a1bca9700bf781c6577ee24e5edf/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/PS5-PRO-hero-Packshot-UK.png",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SONY",
    category: "Gaming/Gaming Consoles",
    variant: "White \u0026 black",
    availableSizes: "[]",
    sku: "N855973W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "544960-440",
    productId: 544960,
    brochureGroupId: 440,
    name: "APPLE AirPods (4th Gen) with Active Noise Cancellation",
    price: 6.88,
    totalAmount: "165.12",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/544960?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjEzMjUwNiwicHVyIjoiYmxvYl9pZCJ9fQ==--1ed168d4aa05beb2c707b0beeeaee09a9fdbce3d/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqZmlmIiwicmVzaXplIjoiNjYweDY2MCJ9LCJwdXIiOiJ2YXJpYXRpb24ifX0=--b5d2386ecc5da19ebb4dc144c9617d5cfad8c61b/Airpods%204.jfif",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Audio/Headphones \u0026 Earphones",
    variant: "",
    availableSizes: "[]",
    sku: "MXP93ZM/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "546739-440",
    productId: 546739,
    brochureGroupId: 440,
    name: "APPLE iPhone 16 Pro Max 256GB Black Titanium",
    price: 45.99,
    totalAmount: "1103.76",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/546739?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NDkyOSwicHVyIjoiYmxvYl9pZCJ9fQ==--35c2d158eae9857fbc90d201bbf9ea0684eac6b9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/iPhone_16_Pro_Black_Titanium_PDP_Image_Position_1__GBEN.png",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Mobile Phones/Apple iPhones",
    variant: "",
    availableSizes: "[]",
    sku: "MYWV3QN/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "546192-440",
    productId: 546192,
    brochureGroupId: 440,
    name: "APPLE AirPods (4th Gen)",
    price: 4.97,
    totalAmount: "119.28",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/546192?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjEzNjk1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--dfba7fc161145ba77a09a4484caefc5e638bf381/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqcGciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--bd1e9154f9f77b290be6cccb7b37553a2410c66a/airpods-4-select-202409_FV1.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Audio/Headphones \u0026 Earphones",
    variant: "",
    availableSizes: "[]",
    sku: "MXP63ZM/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "510131-440",
    productId: 510131,
    brochureGroupId: 440,
    name: "APPLE AirPods Pro (2nd Gen) with USB-C",
    price: 8.8,
    totalAmount: "211.2",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/510131?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTg5NzA0OSwicHVyIjoiYmxvYl9pZCJ9fQ==--289f11d6e27fc60668a867601398531d3c0b8937/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqcGciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--bd1e9154f9f77b290be6cccb7b37553a2410c66a/Airpods.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Audio/Headphones \u0026 Earphones",
    variant: "",
    availableSizes: "[]",
    sku: "MTJV3ZM/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "488463-440",
    productId: 488463,
    brochureGroupId: 440,
    name: "SONY PlayStation 5 Digital Edition (Model Group - Slim)",
    price: 14.95,
    totalAmount: "358.8",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/488463?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MzE1MDQxLCJwdXIiOiJibG9iX2lkIn19--6e0b0219ecd6e702ca0009fbfe9e739720751d28/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/PS5_Slim_Digital.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SONY",
    category: "Gaming/Gaming Consoles",
    variant: "White \u0026 black",
    availableSizes: "[]",
    sku: "N673165W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "204013-440",
    productId: 204013,
    brochureGroupId: 440,
    name: "NINJA Foodi MAX Dual Zone AF400UK Air Fryer - Black",
    price: 8.85,
    totalAmount: "212.4",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/204013?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/7/6/10226767/l_10226767.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "NINJA",
    category: "Small Kitchen Appliances/Fryers",
    variant: "Black",
    availableSizes: "[]",
    sku: "N664306W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "488462-440",
    productId: 488462,
    brochureGroupId: 440,
    name: "SONY PlayStation 5 (Model Group - Slim)",
    price: 18.42,
    totalAmount: "442.08",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/488462?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MzE1MDQwLCJwdXIiOiJibG9iX2lkIn19--8a29af04f6908b7d03b79dcc69d62859bfda787f/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/PS5_Slim.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SONY",
    category: "Gaming/Gaming Consoles",
    variant: "White \u0026 black",
    availableSizes: "[]",
    sku: "N673007W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "546743-440",
    productId: 546743,
    brochureGroupId: 440,
    name: "APPLE iPhone 16 Pro Max 256GB Desert Titanium",
    price: 45.99,
    totalAmount: "1103.76",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/546743?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NDk4NiwicHVyIjoiYmxvYl9pZCJ9fQ==--b6bf2f4ae77a49fb87d3cb5c5293ead2078f9846/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/iPhone_16_Pro_Desert_Titanium_PDP_Image_Position_1__GBEN_2.png",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Mobile Phones/Apple iPhones",
    variant: "",
    availableSizes: "[]",
    sku: "MYWX3QN/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "567701-440",
    productId: 567701,
    brochureGroupId: 440,
    name: "SHARK FW312UK CryoGlow Under-Eye Cooling LED Anti-Ageing \u0026 Blemish Repair Mask - Blue Frost",
    price: 11.55,
    totalAmount: "277.2",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/567701?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjI1MTcwNiwicHVyIjoiYmxvYl9pZCJ9fQ==--ca08a5b454f5b478d953133d4c3f6b3a99e2dc64/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/10271059.jpeg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SHARK",
    category: "Wellbeing \u0026 Home Fragrance/Wellness",
    variant: "Blue Frost",
    availableSizes: "[]",
    sku: "N746828W",
    department: "Beauty \u0026 Accessories",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "474891-440",
    productId: 474891,
    brochureGroupId: 440,
    name: "DYSON V8 Absolute Cordless Vacuum Cleaner - Silver Yellow",
    price: 9.57,
    totalAmount: "229.68",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/474891?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/4/1/10256214/l_10256214.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "DYSON",
    category: "Floorcare/Vacuum Cleaners",
    variant: "Silver yellow",
    availableSizes: "[]",
    sku: "N527470W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "548594-440",
    productId: 548594,
    brochureGroupId: 440,
    name: "APPLE Watch Series 10 - 46 mm Jet Black Aluminium Case with Black Sport Band, M/L",
    price: 15.73,
    totalAmount: "377.52",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/548594?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE0NTI2MywicHVyIjoiYmxvYl9pZCJ9fQ==--bb1d30dd930aa2d899ea8c1a47f0f2c0841619cf/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/10269954.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Smart Tech /Smart Watches",
    variant: "- Bezel: Jet Black- Strap: Black",
    availableSizes: "[]",
    sku: "N396609W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "587479-440",
    productId: 587479,
    brochureGroupId: 440,
    name: "APPLE iPhone 16e 512GB Black",
    price: 34.51,
    totalAmount: "828.24",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/587479?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUxOTg0MCwicHVyIjoiYmxvYl9pZCJ9fQ==--1c724f9760f2e46a22d8aad32dea7f614db31dcf/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqcGVnIiwicmVzaXplIjoiNjYweDY2MCJ9LCJwdXIiOiJ2YXJpYXRpb24ifX0=--13e0873b5db9c2cae2f95eedcbbbbb36c8d8d029/iphone_16e_black_pdp_image_position_1__gben_5%20crop.jpeg",
    productTagName: "new_product",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
    term: 24,
    brand: "APPLE",
    category: "Mobile Phones/Apple iPhones",
    variant: "",
    availableSizes: "[]",
    sku: "MD1X4QN/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "551719-440",
    productId: 551719,
    brochureGroupId: 440,
    name: "APPLE Watch Ultra 2 Cellular - 49 mm Black Titanium Case with Black Trail Loop, S/M",
    price: 30.68,
    totalAmount: "736.32",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/551719?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/5/2/10270825/l_10270825.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Smart Tech /Smart Watches",
    variant: "- Bezel: Black titanium- Strap: Black",
    availableSizes: "[]",
    sku: "N397449W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "473483-440",
    productId: 473483,
    brochureGroupId: 440,
    name: "APPLE iPhone 15 - 128 GB, Black",
    price: 26.85,
    totalAmount: "644.4",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/473483?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjA4NTczMiwicHVyIjoiYmxvYl9pZCJ9fQ==--f5d6c90a9add9168e2d5e482246ac4df1a9f1bcc/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/iPhone_15_-_Black.png",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Mobile Phones/Apple iPhones",
    variant: "Black",
    availableSizes: "[]",
    sku: "MTP03ZD/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "578227-440",
    productId: 578227,
    brochureGroupId: 440,
    name: "DYSON Airwrap I.D. Straight + Wavy Multi-Styler \u0026 Dryer - Ceramic Patina \u0026 Topaz",
    price: 17.29,
    totalAmount: "414.96",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/578227?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/5/2/10274325/l_10274325.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "DYSON",
    category: "Hair Care \u0026 Styling/Hair Stylers",
    variant: "Ceramic Patina \u0026 Topaz",
    availableSizes: "[]",
    sku: "N584013W",
    department: "Beauty \u0026 Accessories",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "546904-440",
    productId: 546904,
    brochureGroupId: 440,
    name: 'TCL 55PF650K Fire TV 55" Smart 4K Ultra HD HDR LED TV with Amazon Alexa',
    price: 11.48,
    totalAmount: "275.52",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/546904?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/6/0/10268406/l_10268406.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "TCL",
    category: "Televisions/Televisions",
    variant: "Brushed titanium metal",
    availableSizes: "[]",
    sku: "B613402B",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "537884-440",
    productId: 537884,
    brochureGroupId: 440,
    name: "SAMSUNG Galaxy Z Fold6 - 256 GB, Silver",
    price: 61.3,
    totalAmount: "1471.2",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/537884?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/9/7/10266779/l_10266779.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "SAMSUNG",
    category: "Mobile Phones/Android Phones",
    variant: "Silver Shadow",
    availableSizes: "[]",
    sku: "N761463W",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "585148-440",
    productId: 585148,
    brochureGroupId: 440,
    name: "GOOGLE Pixel Watch 3 WiFi - Black, Obsidian Band, 45 mm",
    price: 13.4,
    totalAmount: "321.6",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/585148?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/9/4/10268149/l_10268149.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "GOOGLE",
    category: "Smart Tech /Smart Watches",
    variant: "- Bezel: Black- Strap: Obsidian",
    availableSizes: "[]",
    sku: "N797754W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "585147-440",
    productId: 585147,
    brochureGroupId: 440,
    name: "GOOGLE Pixel Watch 3 WiFi - Silver, Porcelain Band, 45 mm",
    price: 13.4,
    totalAmount: "321.6",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/585147?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/7/5/10268157/l_10268157.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "GOOGLE",
    category: "Smart Tech /Smart Watches",
    variant: "- Bezel: Polished silver- Strap: Porcelain",
    availableSizes: "[]",
    sku: "N549629W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "10172-440",
    productId: 10172,
    brochureGroupId: 440,
    name: "INSTAX Mini Film - 20 Shot Pack",
    price: 0.6,
    totalAmount: "14.4",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/10172?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/2/7/10577372/l_10577372.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "INSTAX",
    category: "Camera Accessories/Accessories \u0026 Stands",
    variant: "White",
    availableSizes: "[]",
    sku: "N922774W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "528094-440",
    productId: 528094,
    brochureGroupId: 440,
    name: 'HISENSE 50E7NQTUK 50" Smart 4K Ultra HD HDR QLED TV with Amazon Alexa',
    price: 13.4,
    totalAmount: "321.6",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/528094?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/1/3/10265831/l_10265831.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "HISENSE",
    category: "Televisions/Televisions",
    variant: "Black",
    availableSizes: "[]",
    sku: "B588165B",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "594323-440",
    productId: 594323,
    brochureGroupId: 440,
    name: 'APPLE 11" iPad (2025) - 128 GB, Silver',
    price: 12.62,
    totalAmount: "302.88",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594323?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066.jpg",
    productTagName: "new_product",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
    term: 24,
    brand: "APPLE",
    category: "Tablets \u0026 iPads/Tablets",
    variant: "Silver",
    availableSizes: "[]",
    sku: "N407460W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "546723-440",
    productId: 546723,
    brochureGroupId: 440,
    name: "APPLE iPhone 16 Pro 128GB Black Titanium",
    price: 38.34,
    totalAmount: "920.16",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/546723?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NDg2NSwicHVyIjoiYmxvYl9pZCJ9fQ==--37adfc280fe177984a08a41c3ebadfbf40dbb9aa/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/iPhone_16_Pro_Black_Titanium_PDP_Image_Position_1__GBEN.png",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Mobile Phones/Apple iPhones",
    variant: "",
    availableSizes: "[]",
    sku: "MYND3QN/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "587476-440",
    productId: 587476,
    brochureGroupId: 440,
    name: "APPLE iPhone 16e 512GB White",
    price: 34.51,
    totalAmount: "828.24",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/587476?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUxOTY2NSwicHVyIjoiYmxvYl9pZCJ9fQ==--ed5243ab458625491e004fd5e9b8f3d89178fe0d/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/iPhone%2016e%20-%20White-%20Image%201.png",
    productTagName: "new_product",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
    term: 24,
    brand: "APPLE",
    category: "Mobile Phones/Apple iPhones",
    variant: "",
    availableSizes: "[]",
    sku: "MD274QN/A",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Select (HE)",
    __typename: "Product"
  },
  {
    id: "572710-440",
    productId: 572710,
    brochureGroupId: 440,
    name: "NINJA SLUSHi FS301UK Frozen Drink Maker - Artic Blue \u0026 Grey",
    price: 13.46,
    totalAmount: "323.04",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/572710?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/4/0/10274304/l_10274304.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "NINJA",
    category: "Small Kitchen Appliances/Juicers \u0026 Blenders",
    variant: "Arctic blue \u0026 grey",
    availableSizes: "[]",
    sku: "N549467W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "559384-440",
    productId: 559384,
    brochureGroupId: 440,
    name: "MICROSOFT Xbox Series S - 1 TB SSD",
    price: 11.48,
    totalAmount: "275.52",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/559384?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/6/2/10269626/l_10269626.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "MICROSOFT",
    category: "Gaming/Gaming Consoles",
    variant: "White",
    availableSizes: "[]",
    sku: "N719843W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "551714-440",
    productId: 551714,
    brochureGroupId: 440,
    name: 'JVC LT-50CR530 Roku TV 50" Smart 4K Ultra HD HDR LED TV',
    price: 9.57,
    totalAmount: "229.68",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/551714?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/1/3/10250031/l_10250031.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "JVC",
    category: "Televisions/Televisions",
    variant: "Black",
    availableSizes: "[]",
    sku: "B373480B",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "481942-440",
    productId: 481942,
    brochureGroupId: 440,
    name: "SHARK Lift-Away NV602UK Upright Bagless Vacuum Cleaner - Blue",
    price: 5.02,
    totalAmount: "120.48",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/481942?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/6/2/10257026/l_10257026.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SHARK",
    category: "Floorcare/Vacuum Cleaners",
    variant: "Blue",
    availableSizes: "[]",
    sku: "N695834W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "548503-440",
    productId: 548503,
    brochureGroupId: 440,
    name: "APPLE Watch Series 10 - 42 mm Rose Gold Aluminium Case with Light Blush Sport Band, S/M",
    price: 14.95,
    totalAmount: "358.8",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/548503?bg=440",
    image:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE0NTA1MSwicHVyIjoiYmxvYl9pZCJ9fQ==--edc3e27c012807308815e109fb1314fbe582350c/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--a4801f57b8c90aa95079dae05fed17084034a889/image.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "APPLE",
    category: "Smart Tech /Smart Watches",
    variant: "- Bezel: Rose Gold Aluminium- Strap: Light Blush",
    availableSizes: "[]",
    sku: "N396601W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "561039-440",
    productId: 561039,
    brochureGroupId: 440,
    name: "SHARK HD652SUK FlexFusion Straight 5-in-1 Air Styler \u0026 Hair Dryer with Storage Case - Cosmic Blush",
    price: 14.23,
    totalAmount: "341.52",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/561039?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/2/9/10271092/l_10271092.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SHARK",
    category: "Hair Care \u0026 Styling/Hair Stylers",
    variant: "Cosmic blush",
    availableSizes: "[]",
    sku: "N680179W",
    department: "Beauty \u0026 Accessories",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "518840-440",
    productId: 518840,
    brochureGroupId: 440,
    name: "NINJA Double Stack XL SL400UK Air Fryer - Grey",
    price: 10.41,
    totalAmount: "249.84",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/518840?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/4/6/10261664/l_10261664.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "NINJA",
    category: "Small Kitchen Appliances/Fryers",
    variant: "Grey",
    availableSizes: "[]",
    sku: "N663757W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "522069-440",
    productId: 522069,
    brochureGroupId: 440,
    name: 'SAMSUNG UE55DU7100KXXU 55" Smart 4K Ultra HD HDR LED TV with Bixby',
    price: 13.4,
    totalAmount: "321.6",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/522069?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/5/5/10263155/l_10263155.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "SAMSUNG",
    category: "Televisions/Televisions",
    variant: "Black",
    availableSizes: "[]",
    sku: "B598153B",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "466449-440",
    productId: 466449,
    brochureGroupId: 440,
    name: 'HP 15s-fq0501sa 15.6" Laptop - Intel® Pentium® Silver, 128 GB SSD, Black',
    price: 9.21,
    totalAmount: "221.04",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/466449?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/6/6/10250266/l_10250266.jpg",
    productTagName: null,
    productTagImage: null,
    term: 24,
    brand: "HP",
    category: "Laptops \u0026 Macbooks/Laptops",
    variant: "Jet black",
    availableSizes: "[]",
    sku: "N531447W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "596262-440",
    productId: 596262,
    brochureGroupId: 440,
    name: "SONY PlayStation 5 Astro Bot Bundle (Model Group - Slim)",
    price: 16.45,
    totalAmount: "394.8",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/596262?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/1/9/10278691/l_10278691.jpg",
    productTagName: "new_product",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
    term: 24,
    brand: "SONY",
    category: "Gaming/Gaming Consoles",
    variant: "White",
    availableSizes: "[]",
    sku: "N782301W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "585150-440",
    productId: 585150,
    brochureGroupId: 440,
    name: "GOOGLE Pixel Watch 3 WiFi - Silver, Porcelain Band, 41 mm",
    price: 11.48,
    totalAmount: "275.52",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/585150?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/2/6/10268162/l_10268162.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "GOOGLE",
    category: "Smart Tech /Smart Watches",
    variant: "- Bezel: Polished silver- Strap: Porcelain",
    availableSizes: "[]",
    sku: "N565930W",
    department: "Appliances \u0026 Smart Tech",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "536661-440",
    productId: 536661,
    brochureGroupId: 440,
    name: "SAMSUNG Galaxy Z Flip6 - 512 GB, Blue",
    price: 38.34,
    totalAmount: "920.16",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/536661?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/4/7/10266774/l_10266774.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "SAMSUNG",
    category: "Mobile Phones/Android Phones",
    variant: "Blue",
    availableSizes: "[]",
    sku: "N735785W",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "257322-440",
    productId: 257322,
    brochureGroupId: 440,
    name: "JLAB Go Air Sport Wireless Bluetooth Earbuds - Graphite",
    price: 1.02,
    totalAmount: "24.48",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/257322?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/6/4/10238046/l_10238046.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "JLAB",
    category: "Audio/Headphones \u0026 Earphones",
    variant: "Graphite",
    availableSizes: "[]",
    sku: "N558839W",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "555398-440",
    productId: 555398,
    brochureGroupId: 440,
    name: "SAMSUNG Galaxy S24 FE 5G - 256 GB, Grey",
    price: 22.96,
    totalAmount: "551.04",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/555398?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/1/8/10271581/l_10271581.jpg",
    productTagName: "spring_savings",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjUyNDM1NSwicHVyIjoiYmxvYl9pZCJ9fQ==--06d4ee541cc32e2a9c25983d5c76b376dd41bbb9/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/Spring%20Savings%20(3)%201.png",
    term: 24,
    brand: "SAMSUNG",
    category: "Mobile Phones/Android Phones",
    variant: "Grey",
    availableSizes: "[]",
    sku: "N551314W",
    department: "TV, Audio \u0026 Phones",
    supplierName: "Currys (HE)",
    __typename: "Product"
  },
  {
    id: "594319-440",
    productId: 594319,
    brochureGroupId: 440,
    name: 'APPLE 11" iPad (2025) - 128 GB, Blue',
    price: 12.62,
    totalAmount: "302.88",
    url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594319?bg=440",
    image: "https://brain-images-ssl.cdn.dixons.com/7/6/10277067/l_10277067.jpg",
    productTagName: "new_product",
    productTagImage:
      "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
    term: 24,
    brand: "APPLE",
    category: "Tablets \u0026 iPads/Tablets",
    variant: "Blue",
    availableSizes: "[]",
    sku: "N407462W",
    department: "Computing \u0026 Gaming",
    supplierName: "Currys (HE)",
    __typename: "Product"
  }
]

export const product = {
  id: "594323-440",
  productId: 594323,
  brochureGroupId: 440,
  name: 'APPLE 11" iPad (2025) - 128 GB, Silver',
  description:
    "iPadOS, Liquid Retina display, 128 GB storage: Perfect for saving pretty much everything, Battery life: Up to 10 hours, Compatible with Apple Pencil (USB-C)",
  price: 12.62,
  url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594323?bg=440",
  image: "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066.jpg",
  productTagName: "new_product",
  productTagImage:
    "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
  productImages: [
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_002.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_003.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_004.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_005.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_006.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_007.jpg",
    "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066_008.jpg"
  ],
  summary:
    "\u003cp\u003eYour Apple iPad is up for anything \u0026ndash; shoot and edit 4K video, draw a digital masterpiece or just watch some Apple TV. The superfast\u0026nbsp;\u003cstrong\u003eA16 Bionic chip\u003c/strong\u003e\u0026nbsp;can do it all without skipping a beat. The \u003cstrong\u003e11\u0026quot;\u003c/strong\u003e\u0026nbsp;\u003cstrong\u003eLiquid Retina Display\u003c/strong\u003e\u0026nbsp;is just beautiful, with high resolution, amazing colours and thin bezels. On the back, the\u0026nbsp;\u003cstrong\u003e12 MP camera\u003c/strong\u003e\u0026nbsp;takes 4K video and stunning photos. The front camera\u0026#39;s also 12 MP and uses\u0026nbsp;\u003cstrong\u003eCentre Stage\u003c/strong\u003e\u0026nbsp;to keep you front and centre during video calls. And getting to all these features is super easy and secure with\u0026nbsp;\u003cstrong\u003eTouch ID\u0026nbsp;\u003c/strong\u003efingerprint scanner in the power button.\u003cbr /\u003e\r\n\u003cbr /\u003e\r\n\u003cstrong\u003eGood to know\u003c/strong\u003e\u003cbr /\u003e\r\n\u003cbr /\u003e\r\n-\u0026nbsp;\u003cstrong\u003eiPadOS\u003c/strong\u003e\u0026nbsp;makes multitasking easier than ever \u0026ndash; helping you be more productive than ever\u003cbr /\u003e\r\n- The\u0026nbsp;\u003cstrong\u003e12 MP front camera\u003c/strong\u003e\u0026nbsp;is now in a landscape orientation, which is perfect for FaceTime\u003cbr /\u003e\r\n- With\u0026nbsp;\u003cstrong\u003eWiFi 6\u003c/strong\u003e,\u0026nbsp;you\u0026#39;ll have fast and rock-solid internet connection\u003cbr /\u003e\r\n-\u0026nbsp;\u003cstrong\u003eTrue Tone\u003c/strong\u003e\u0026nbsp;adjusts the display to the colour temperature of the room\u003cbr /\u003e\r\n- A single charge gives you up to\u0026nbsp;\u003cstrong\u003e10 hours of battery life\u003c/strong\u003e\u0026nbsp;\u0026ndash; plenty of time for work and fun\u003c/p\u003e\r\n",
  techSpecs:
    '\u003ctable\u003e\r\n\t\u003ctbody\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003eOVERVIEW\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eType\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eiPad\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eOperating system\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eiPadOS\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003ePERFORMANCE\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eProcessor\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e- A16 Bionic chip- 5-core CPU- 4-core graphics- 16-core Neural Engine\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eStorage\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e128 GB\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003eSCREEN\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eTouchscreen\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eYes\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eScreen size\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e11\u0026quot;\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eScreen type\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eLiquid Retina display\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eResolution\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e2360 x 1640p\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eScreen features\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e- LED backlighting- IPS technology- True Tone display- 264 ppi- 500 nits brightness- Fingerprint-resistant oleophobic coating- Supports Apple Pencil (1st generation)\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003eCONNECTIVITY\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eWiFi\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eDual-band WiFi 6\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eBluetooth\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eBluetooth 5.3\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eUSB\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eUSB Type-C x 1\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eOther connections\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eSmart connector\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003eSOUND\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eSpeakers\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eStereo speakers\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003eFEATURES\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eCamera\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e- Rear: 12 MP Wide camera- Front: 12 MP Ultra Wide camera\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eSecurity features\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eTouch ID\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eOther features\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e- 4K video recording on main camera- Centre Stage on front camera\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003ePOWER\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eBattery type\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eLithium-polymer battery\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eBattery life\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eUp to 10 hours\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd colspan="\\\u0026quot;2\\\u0026quot;" style="\\\u0026quot;height:20px;" width:571px=""\u003eGENERAL\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eColour\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003eSilver\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eBox contents\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e- Apple 11\u0026quot; iPad- USB Type-C cable (1 m)\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eDimensions\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e7 x 179.5 x 248.6 mm (H x W x D)\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eWeight\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e477 g\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\t\u003ctr\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;height:20px;" width:285px=""\u003eManufacturer\u0026rsquo;s guarantee\u003c/td\u003e\r\n\t\t\t\u003ctd style="\\\u0026quot;width:285px\\\u0026quot;"\u003e1 year\u003c/td\u003e\r\n\t\t\u003c/tr\u003e\r\n\t\u003c/tbody\u003e\r\n\u003c/table\u003e\r\n',
  availableSizes: "[]",
  supplierDesktopBanner:
    "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTQ3OCwicHVyIjoiYmxvYl9pZCJ9fQ==--becde9674a4567178bbb1de370daea6abeffac36/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIzODQweDEwMFx1MDAzZSJ9LCJwdXIiOiJ2YXJpYXRpb24ifX0=--dea7a2adde921a07d077dfd4a129929ed65de4ab/Currys.png",
  supplierMobileBanner:
    "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTQ3OSwicHVyIjoiYmxvYl9pZCJ9fQ==--50b76fe9a6deada8e068343ac71ac69a69626820/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiIxMDgweDEwMFx1MDAzZSJ9LCJwdXIiOiJ2YXJpYXRpb24ifX0=--54501e95b2e67203ee9728b4c58071a6ff16840e/Currys.png",
  totalAmount: "302.88",
  brand: "APPLE",
  category: "Tablets \u0026 iPads/Tablets",
  variant: "Silver",
  sku: "N407460W",
  supplierName: "Currys (HE)",
  department: "Computing \u0026 Gaming",
  savings: null,
  recommendedRetailPrice: 328.99,
  reachedMaximumQuantity: false,
  maximumQuantity: null,
  status: "default",
  releaseDate: null,
  preBackOrderProductMessage: "",
  recommendations: [
    {
      id: "538518-440",
      productId: 538518,
      brochureGroupId: 440,
      name: "PANASONIC KX-TGU433EB Cordless Phone - Triple Handsets, Silver \u0026 Black",
      price: 3.89,
      totalAmount: "93.36",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/538518?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/8/9/10266298/l_10266298.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "PANASONIC",
      category: "Telephones/Telephones",
      variant: "Silver \u0026 black",
      availableSizes: "[]",
      sku: "N647544W",
      supplierName: "Currys (HE)",
      department: "TV, Audio \u0026 Phones",
      __typename: "Product"
    },
    {
      id: "524253-440",
      productId: 524253,
      brochureGroupId: 440,
      name: "APPLE Pencil Pro",
      price: 4.61,
      totalAmount: "110.64",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/524253?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/2/5/10264752/l_10264752.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablet Cases",
      variant: "White",
      availableSizes: "[]",
      sku: "N391940W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "544960-440",
      productId: 544960,
      brochureGroupId: 440,
      name: "APPLE AirPods (4th Gen) with Active Noise Cancellation",
      price: 6.88,
      totalAmount: "165.12",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/544960?bg=440",
      image:
        "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjEzMjUwNiwicHVyIjoiYmxvYl9pZCJ9fQ==--1ed168d4aa05beb2c707b0beeeaee09a9fdbce3d/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqZmlmIiwicmVzaXplIjoiNjYweDY2MCJ9LCJwdXIiOiJ2YXJpYXRpb24ifX0=--b5d2386ecc5da19ebb4dc144c9617d5cfad8c61b/Airpods%204.jfif",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Audio/Headphones \u0026 Earphones",
      variant: "",
      availableSizes: "[]",
      sku: "MXP93ZM/A",
      supplierName: "Select (HE)",
      department: "TV, Audio \u0026 Phones",
      __typename: "Product"
    },
    {
      id: "565901-440",
      productId: 565901,
      brochureGroupId: 440,
      name: "VELD Super-Fast VH20BW 20 W USB Type-C Wall Charger",
      price: 0.54,
      totalAmount: "12.96",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/565901?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/3/2/10271623/l_10271623.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "VELD",
      category: "Household Consumables/Cables and Adaptors",
      variant: "White",
      availableSizes: "[]",
      sku: "N632925W",
      supplierName: "Currys (HE)",
      department: "Appliances \u0026 Smart Tech",
      __typename: "Product"
    },
    {
      id: "146440-440",
      productId: 146440,
      brochureGroupId: 440,
      name: "APPLE AirTag Bluetooth Tracker",
      price: 1.08,
      totalAmount: "25.92",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/146440?bg=440",
      image:
        "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjExOTMzLCJwdXIiOiJibG9iX2lkIn19--16793a2565c18c88ff626ec701b2adddd71d8463/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqcGciLCJyZXNpemUiOiI2NjB4NjYwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--bd1e9154f9f77b290be6cccb7b37553a2410c66a/image20210428-15-ax5vah.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Mobile Phone Accessories/Chargers, Adaptors \u0026 Cables",
      variant: "White",
      availableSizes: "[]",
      sku: "N332269W",
      supplierName: "Currys (HE)",
      department: "TV, Audio \u0026 Phones",
      __typename: "Product"
    },
    {
      id: "253022-440",
      productId: 253022,
      brochureGroupId: 440,
      name: "Vango Nova 200 Rechargeable USB Lantern",
      price: 0.84,
      totalAmount: "20.16",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/253022?bg=440",
      image: "https://media.johnlewiscontent.com/i/JohnLewis/239882751",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "VANGO",
      category: "Picnic \u0026 Camping/Camping Equipment",
      variant: "Wood",
      availableSizes: "[]",
      sku: "35126227",
      supplierName: "John Lewis \u0026 Partners (HE)",
      department: "Sport \u0026 Leisure",
      __typename: "Product"
    },
    {
      id: "168619-440",
      productId: 168619,
      brochureGroupId: 440,
      name: "Gucci Flora Gorgeous Gardenia Eau de Parfum For Women - 100ml",
      price: 4.43,
      totalAmount: "106.32",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/168619?bg=440",
      image: "https://media.johnlewiscontent.com/i/JohnLewis/240129416",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "GUCCI",
      category: "Fragrance/Perfume",
      variant: "",
      availableSizes: '["100ml"]',
      sku: "46919735",
      supplierName: "John Lewis \u0026 Partners (HE)",
      department: "Beauty \u0026 Accessories",
      __typename: "Product"
    },
    {
      id: "565908-440",
      productId: 565908,
      brochureGroupId: 440,
      name: "PHILIPS PureProtect Mini 900 Series AC0921/14 Air Purifier - Silk Beige",
      price: 3.83,
      totalAmount: "91.92",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/565908?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/5/7/10271275/l_10271275.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "PHILIPS",
      category: "Heating and Cooling/Air Purifiers",
      variant: "Silk Beige",
      availableSizes: "[]",
      sku: "N747366W",
      supplierName: "Currys (HE)",
      department: "Appliances \u0026 Smart Tech",
      __typename: "Product"
    },
    {
      id: "582592-440",
      productId: 582592,
      brochureGroupId: 440,
      name: "ProForm Sport Treadmill",
      price: 22.96,
      totalAmount: "551.04",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/582592?bg=440",
      image: "https://media.johnlewiscontent.com/i/JohnLewis/112273318",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "PROFORM",
      category: "Fitness \u0026 Gym/Treadmills",
      variant: "Black",
      availableSizes: "[]",
      sku: "49948106",
      supplierName: "John Lewis \u0026 Partners (HE)",
      department: "Sport \u0026 Leisure",
      __typename: "Product"
    }
  ],
  recommendationsSimilarProducts: [
    {
      id: "594342-440",
      productId: 594342,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Air (2025) - 128 GB, Starlight',
      price: 22.96,
      totalAmount: "551.04",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594342?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/1/7/10278871/l_10278871.jpg",
      productTagName: "new_product",
      productTagImage:
        "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Starlight",
      availableSizes: "[]",
      sku: "N410161W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594284-440",
      productId: 594284,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Air (2025) - 128 GB, Space Grey',
      price: 22.96,
      totalAmount: "551.04",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594284?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/9/6/10278869/l_10278869.jpg",
      productTagName: "new_product",
      productTagImage:
        "https://www.vivup.co.uk/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MjE5NTU3MiwicHVyIjoiYmxvYl9pZCJ9fQ==--22cb0bfd51c91b78752f7240b75a4807b341b799/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJwbmciLCJyZXNpemUiOiI4MDB4ODAwIn0sInB1ciI6InZhcmlhdGlvbiJ9fQ==--7fd7333d6b2d1594bfc293e641437584d9c31a76/new_product_tag.png",
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Space grey",
      availableSizes: "[]",
      sku: "N410157W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594290-440",
      productId: 594290,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Air (2025) - 128 GB, Purple',
      price: 22.96,
      totalAmount: "551.04",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594290?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/2/7/10278872/l_10278872.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Purple",
      availableSizes: "[]",
      sku: "N410162W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594288-440",
      productId: 594288,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Air (2025) - 256 GB, Space Grey',
      price: 26.85,
      totalAmount: "644.4",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594288?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/3/7/10278873/l_10278873.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Space Grey",
      availableSizes: "[]",
      sku: "N410163W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594291-440",
      productId: 594291,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Air Cellular (2025) - 128 GB, Space Grey',
      price: 28.77,
      totalAmount: "690.48",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594291?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/5/8/10278885/l_10278885.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Space Grey",
      availableSizes: "[]",
      sku: "N410181W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "524058-440",
      productId: 524058,
      brochureGroupId: 440,
      name: 'APPLE 13" iPad Pro (2024) - 256 GB, Space Black',
      price: 49.82,
      totalAmount: "1195.68",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/524058?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/2/0/10264702/l_10264702.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Space black",
      availableSizes: "[]",
      sku: "N391658W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594324-440",
      productId: 594324,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Cellular (2025) - 128 GB, Blue',
      price: 18.42,
      totalAmount: "442.08",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594324?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/9/7/10277079/l_10277079.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Blue",
      availableSizes: "[]",
      sku: "N407478W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594292-440",
      productId: 594292,
      brochureGroupId: 440,
      name: 'APPLE 11" iPad Air (2025) - 256 GB, Purple',
      price: 26.85,
      totalAmount: "644.4",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594292?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/6/7/10278876/l_10278876.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Purple",
      availableSizes: "[]",
      sku: "N410168W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    },
    {
      id: "594293-440",
      productId: 594293,
      brochureGroupId: 440,
      name: 'APPLE 13" iPad Air (2025) - 128 GB, Purple',
      price: 30.68,
      totalAmount: "736.32",
      url: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594293?bg=440",
      image: "https://brain-images-ssl.cdn.dixons.com/3/2/10278923/l_10278923.jpg",
      productTagName: null,
      productTagImage: null,
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Purple",
      availableSizes: "[]",
      sku: "N410231W",
      supplierName: "Currys (HE)",
      department: "Computing \u0026 Gaming",
      __typename: "Product"
    }
  ],
  breadcrumbs: [
    {
      label: "Home and Electronics",
      link: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/landing",
      forceLink: null,
      __typename: "Breadcrumbs"
    },
    {
      label: "Computing \u0026 Gaming",
      link: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products?departments=15",
      forceLink: null,
      __typename: "Breadcrumbs"
    },
    {
      label: "Tablets \u0026 iPads",
      link: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products?categories=147\u0026departments=15",
      forceLink: null,
      __typename: "Breadcrumbs"
    },
    {
      label: "Tablets",
      link: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products?categories=147\u0026departments=15\u0026subcategories=195",
      forceLink: true,
      __typename: "Breadcrumbs"
    }
  ],
  __typename: "Product"
}

export const basket = {
  id: "4541323",
  count: 2,
  monthlyPrice: 22.97,
  term: 24,
  totalMonthlyGrossAmount: 24.97,
  disposalFee: null,
  endOfAgreementFee: null,
  totalSavings: null,
  totalRrp: 597.98,
  __typename: "Basket",
  basketItems: [
    {
      id: "2677007",
      productId: "594323",
      brochureGroupId: "440",
      name: 'APPLE 11" iPad (2025) - 128 GB, Silver',
      link: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/594323?bg=440",
      quantity: 1,
      imageUrl: "https://brain-images-ssl.cdn.dixons.com/6/6/10277066/l_10277066.jpg",
      price: 12.62,
      totalAmount: "302.88",
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablets",
      variant: "Silver",
      sku: "N407460W",
      storeName: "Home and Electronics",
      department: "Computing \u0026 Gaming",
      supplierName: "Currys (HE)",
      status: "default",
      releaseDate: null,
      __typename: "BasketItem"
    },
    {
      id: "2677128",
      productId: "595608",
      brochureGroupId: "440",
      name: 'APPLE iPad Air 11" (M3) Magic Keyboard - White',
      link: "/organisations/130-smehci-ltd/employee/benefits/home_and_electronics/products/595608?bg=440",
      quantity: 1,
      imageUrl: "https://brain-images-ssl.cdn.dixons.com/1/8/10277481/l_10277481.jpg",
      price: 10.35,
      totalAmount: "248.4",
      term: 24,
      brand: "APPLE",
      category: "Tablets \u0026 iPads/Tablet Cases",
      variant: "White",
      sku: "N408130W",
      storeName: "Home and Electronics",
      department: "Computing \u0026 Gaming",
      supplierName: "Currys (HE)",
      status: "default",
      releaseDate: null,
      __typename: "BasketItem"
    }
  ],
  brochureGroupId: 440,
  headroomValue: null,
  limitationMessage: {}
}
